// Application Configuration
export const APP_NAME = 'Sarabi';
export const APP_DESCRIPTION = `${APP_NAME} - AI Companion for Autistic Kids`;
